import { Pipe, PipeTransform } from '@angular/core';
import { OrderStatusMappingValues } from '@zero/shared/util-models';

@Pipe({
  name: 'displayLabel',
  standalone: true,
})
export class DisplayLabelPipe implements PipeTransform {
  public static transformstatic(value: string): string {
    const transformed = OrderStatusMappingValues[value];
    return transformed ? transformed : value;
  }

  public transform(value: string): string {
    return DisplayLabelPipe.transformstatic(value);
  }
}
